export default __webpack_public_path__ + "static/media/Group1540.c574975d.png";